import React, { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import "../../styles/global.css";

export const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};
